module.exports = __webpack_public_path__ + "static/media/6_sozial_frei.2c1bfc0d.png";